import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiCalendar, FiMessageCircle, FiSend } = FiIcons;

const ContactStrip = () => {
  const channels = [
    {
      label: "קביעת דמו",
      url: "https://link.botley.co.il/botley_demo_website",
      icon: FiCalendar,
      color: "bg-blue-500 hover:bg-blue-600"
    },
    {
      label: "וואטסאפ", 
      url: "https://link.botley.co.il/AI_agent",
      icon: FiMessageCircle,
      color: "bg-green-500 hover:bg-green-600"
    },
    {
      label: "טלגרם",
      url: "https://link.botley.co.il/Botley-bot", 
      icon: FiSend,
      color: "bg-blue-400 hover:bg-blue-500"
    }
  ];

  return (
    <section className="contact-strip section bg-white">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
            יצירת קשר מהיר
          </h2>
        </motion.div>
        
        <div className="contact-channels flex flex-col sm:flex-row gap-6 justify-center max-w-3xl mx-auto">
          {channels.map((channel, index) => (
            <motion.a
              key={index}
              href={channel.url}
              target="_blank"
              rel="noopener noreferrer"
              className={`contact-channel ${channel.color} text-white px-8 py-4 rounded-2xl flex items-center justify-center gap-3 text-lg font-semibold transition-all duration-300 shadow-lg hover:shadow-xl flex-1`}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              whileHover={{ y: -3 }}
            >
              <SafeIcon icon={channel.icon} />
              {channel.label}
            </motion.a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ContactStrip;